export default __webpack_public_path__ + "static/media/donate.1cf39d40.png";